export const validateWidefoneImportFile = (keys: string[]) => {
  let result: string = "";
  if (!keys.includes('id')) {
    result += "\r\nフィールド「id」が不足しています。";
  }
  if (!keys.includes('phone')) {
    result += "\r\nフィールド「phone」が不足しています。";
  }
  if (!keys.includes('email')) {
    result += "\r\nフィールド「email」が不足しています。";
  }
  if (!keys.includes('category')) {
    result += "\r\nフィールド「category」が不足しています。";
  }
  if (!keys.includes('contactType')) {
    result += "\r\nフィールド「contactType」が不足しています。";
  }
  if (!keys.includes('contactName')) {
    result += "\r\nフィールド「contactName」が不足しています。";
  }
  if (!keys.includes('firstName')) {
    result += "\r\nフィールド「firstName」が不足しています。";
  }
  if (!keys.includes('lastName')) {
    result += "\r\nフィールド「lastName」が不足しています。";
  }
  if (!keys.includes('firstNameKana')) {
    result += "\r\nフィールド「firstNameKana」が不足しています。";
  }
  if (!keys.includes('lastNameKana')) {
    result += "\r\nフィールド「lastNameKana」が不足しています。";
  }
  if (!keys.includes('organization')) {
    result += "\r\nフィールド「organization」が不足しています。";
  }
  if (!keys.includes('department')) {
    result += "\r\nフィールド「department」が不足しています。";
  }
  if (!keys.includes('position')) {
    result += "\r\nフィールド「position」が不足しています。";
  }
  if (!keys.includes('mobilePhone')) {
    result += "\r\nフィールド「mobilePhone」が不足しています。";
  }
  if (!keys.includes('telExtension')) {
    result += "\r\nフィールド「telExtension」が不足しています。";
  }
  if (!keys.includes('altEmail')) {
    result += "\r\nフィールド「altEmail」が不足しています。";
  }
  if (!keys.includes('fax')) {
    result += "\r\nフィールド「fax」が不足しています。";
  }
  if (!keys.includes('postalCode')) {
    result += "\r\nフィールド「postalCode」が不足しています。";
  }
  if (!keys.includes('address1')) {
    result += "\r\nフィールド「address1」が不足しています。";
  }
  if (!keys.includes('address2')) {
    result += "\r\nフィールド「address2」が不足しています。";
  }
  if (!keys.includes('city')) {
    result += "\r\nフィールド「city」が不足しています。";
  }
  if (!keys.includes('prefecture')) {
    result += "\r\nフィールド「prefecture」が不足しています。";
  }
  if (!keys.includes('country')) {
    result += "\r\nフィールド「country」が不足しています。";
  }
  // if (!keys.includes('site')) {
  //   result += "\r\nフィールド「site」が不足しています。";
  // }
  // if (!keys.includes('linkedIn')) {
  //   result += "\r\nフィールド「linkedIn」が不足しています。";
  // }
  // if (!keys.includes('facebook')) {
  //   result += "\r\nフィールド「facebook」が不足しています。";
  // }
  // if (!keys.includes('twitter')) {
  //   result += "\r\nフィールド「twitter」が不足しています。";
  // }
  // if (!keys.includes('skype')) {
  //   result += "\r\nフィールド「skype」が不足しています。";
  // }
  // if (!keys.includes('slack')) {
  //   result += "\r\nフィールド「slack」が不足しています。";
  // }
  // if (!keys.includes('github')) {
  //   result += "\r\nフィールド「github」が不足しています。";
  // }
  // if (!keys.includes('youtube')) {
  //   result += "\r\nフィールド「youtube」が不足しています。";
  // }
  // if (!keys.includes('tiktok')) {
  //   result += "\r\nフィールド「tiktok」が不足しています。";
  // }
  // if (!keys.includes('spotify')) {
  //   result += "\r\nフィールド「spotify」が不足しています。";
  // }
  // if (!keys.includes('discord')) {
  //   result += "\r\nフィールド「discord」が不足しています。";
  // }
  // if (!keys.includes('isFavorite')) {
  //   result += "\r\nフィールド「isFavorite」が不足しています。";
  // }
  // if (!keys.includes('birthday')) {
  //   result += "\r\nフィールド「birthday」が不足しています。";
  // }
  // if (!keys.includes('memo')) {
  //   result += "\r\nフィールド「memo」が不足しています。";
  // }
  // if (!keys.includes('profileImage')) {
  //   result += "\r\nフィールド「profileImage」が不足しています。";
  // }
  // if (!keys.includes('mimeType')) {
  //   result += "\r\nフィールド「mimeType」が不足しています。";
  // }
  // if (!keys.includes('createdDate')) {
  //   result += "\r\nフィールド「createdDate」が不足しています。";
  // }
  // if (!keys.includes('updatedDate')) {
  //   result += "\r\nフィールド「updatedDate」が不足しています。";
  // }

  return result;
}
